import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { listFolders } from "utils/collegeDocumentService";
import { FOLDERS_QUERY_KEY } from "./documentLibraryQueryKeys";

/**
 * Loads the flat folder list for a university and derives an id lookup plus the breadcrumb
 * trail for the currently selected folder from its slash-terminated `idPath` (e.g. "/40/57/").
 */
export const useFolderData = (universityId, selectedFolderId) => {
  const foldersQuery = useQuery({
    queryKey: [FOLDERS_QUERY_KEY, universityId],
    queryFn: () => listFolders(universityId),
  });

  const folders = useMemo(() => foldersQuery.data || [], [foldersQuery.data]);

  const foldersById = useMemo(
    () => Object.fromEntries(folders.map((folder) => [folder.id, folder])),
    [folders]
  );

  const breadcrumb = useMemo(() => {
    const folder = foldersById[selectedFolderId];
    if (!folder) return [];
    return folder.idPath
      .split("/")
      .filter(Boolean)
      .map((id) => foldersById[Number(id)])
      .filter(Boolean);
  }, [foldersById, selectedFolderId]);

  return { folders, breadcrumb, isLoading: foldersQuery.isLoading };
};
